import { cptData, diagnosisQualifiers, icd10CmData, icd9CmData, drgData } from './codeData';


export function getDiagnosisMeta(dx){

  let qualifier = dx.qualifier;
  let code = dx.code;

  let dxLookup = diagnosisQualifiers[qualifier];
  if(dxLookup == undefined){
    dxLookup = {
      description: "SEARCHING",
      type: "INVALID"
    }
  }
  let type = dxLookup.type;
  
  let dataSource = null;
  if(type == "DRG"){
    dataSource = drgData;
  }else if(type == "ICD-10-CM"){
    code = code.substring(0, 3);
    dataSource = icd10CmData;
  }else if(type == "ICD-9-CM"){
    dataSource = icd9CmData;
  }else{
    dataSource = null;
  }

  let foundSection = null;
  let foundSectionKey = '';
  let foundSubsection = null;
  let foundSubsectionKey = '';

  if(dataSource){
    
    // For ICD codes, use string comparison since they can be alphanumeric
    for (const [sectionKey, section] of Object.entries(dataSource)) {
      if (code >= section.rangeStart && code <= section.rangeEnd) {
        foundSection = section;
        foundSectionKey = sectionKey;
        // Find subsection if exists
        if (section.subsections) {
          for (const [subKey, sub] of Object.entries(section.subsections)) {
            if (code >= sub.rangeStart && code <= sub.rangeEnd) {
              foundSubsection = sub;
              foundSubsectionKey = subKey;
              break;
            }
          }
        }
        break;
      }
    }
  }

  let meta = {
    color: foundSection?.color || "#000",
    icon: foundSection?.icon || null,
    section: foundSectionKey.replace(/_/g, ' '),
    description: foundSection?.description || null,
    // description: dxLookup.description
  }


  return meta;
}

export function getCodeMeta(code, data = cptData){

  let foundSection = null;
  let foundSubsection = null;
  let foundSectionKey = '';
  let foundSubsectionKey = '';

  const numCode = parseInt(code, 10);
  // Find section
  for (const [sectionKey, section] of Object.entries(data)) {
    if (numCode >= section.rangeStart && numCode <= section.rangeEnd) {
      foundSection = section;
      foundSectionKey = sectionKey;
      // Find subsection if exists
      if (section.subsections) {
        for (const [subKey, sub] of Object.entries(section.subsections)) {
          if (numCode >= sub.rangeStart && numCode <= sub.rangeEnd) {
            foundSubsection = sub;
            foundSubsectionKey = subKey;
            break;
          }
        }
      }
      break;
    }
  }

  let meta = {
    section: null,
    sectionColor: null,
    sectionIcon: null,
    subSection: null,
    subSectionColor: null,
    subSectionIcon: null,
    description: null
  }
  // Set color and icons
  if (foundSection) {
    meta.section = foundSectionKey.replace(/_/g, ' ');
    meta.sectionColor = foundSection.color || '#000';
    meta.sectionIcon = foundSection.icon || null;
    meta.description = foundSection.description || '';
  } else {
    meta.section = '';
    meta.sectionColor = null;
    meta.sectionIcon = null;
    meta.description = '';
  }
  if (foundSubsection) {
    meta.subSection = foundSubsectionKey.replace(/_/g, ' ');
    meta.subSectionColor = foundSubsection.color || foundSection?.color || '#000';
    meta.subSectionIcon = foundSubsection.icon || null;
  } else {
    meta.subSection = '';
    meta.subSectionColor = foundSection?.color || '#000';
    meta.subSectionIcon = null;
  }

  return meta;

}

export function getCptDetails(code, data = cptData) {
    const numCode = parseInt(code, 10);
  
    for (const [sectionName, sectionData] of Object.entries(data)) {
      if (numCode >= sectionData.rangeStart && numCode <= sectionData.rangeEnd) {
        // Check for subsections, if any
        if (sectionData.subsections) {
          for (const [subName, subData] of Object.entries(sectionData.subsections)) {
            if (numCode >= subData.rangeStart && numCode <= subData.rangeEnd) {
              return {
                section: sectionName.replace(/_/g, ' '),
                subsection: subName.replace(/_/g, ' '),
                code: code,
                description: `Code ${code} is in subsection ${subName.replace(/_/g, ' ')} of ${sectionName.replace(/_/g, ' ')}`
              };
            }
          }
        }
        // No subsection match, but section matched
        return {
          section: sectionName.replace(/_/g, ' '),
          code: code,
          description: `Code ${code} is in section ${sectionName.replace(/_/g, ' ')}`
        };
      }
    }
  
    return { error: `Code ${code} not found in CPT Category I data.` };
}


  